import { render } from "./ExportResults.vue?vue&type=template&id=1852551b"
import script from "./ExportResults.vue?vue&type=script&lang=js"
export * from "./ExportResults.vue?vue&type=script&lang=js"

import exportComponent from "/data/local/webspace/artflsrv04/html/philologic4.7/publicdicos/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__